import script from "./audit-log-attribute-change.vue?vue&type=script&setup=true&lang=ts"
export * from "./audit-log-attribute-change.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__